// extracted by mini-css-extract-plugin
module.exports = {"filter-box":"filter-box_3BBD","type-select":"type-select_3kEF"};